import { ReactNode } from "react";

type ScreenHeaderProps = {
  title?: string;
  subtitle?: string;
  /** Optional control left of the brand (e.g. a round back button). */
  leading?: ReactNode;
  /** Optional control on the far right of the header. */
  action?: ReactNode;
};

/** MOSIDA / MAKE A WISH brand lockup at the top of each screen. */
const ScreenHeader = ({
  title = "MOSIDA",
  subtitle = "MAKE A WISH",
  leading,
  action,
}: ScreenHeaderProps) => (
  <header className="screenHeader">
    <div className="screenHeader__start">
      {leading ? <div className="screenHeader__leading">{leading}</div> : null}
      <div className="screenHeader__brand" aria-label={`${title} ${subtitle}`}>
        <div className="screenHeader__title">{title}</div>
        {subtitle ? <div className="screenHeader__subtitle">{subtitle}</div> : null}
      </div>
    </div>
    {action ? <div className="screenHeader__action">{action}</div> : null}
  </header>
);

export default ScreenHeader;
